import { BaseService } from 'core/services';
import NikoPatientDetailInsuranceRouteService from './NikoPatientDetailInsuranceRouteService';

class NikoPatientDetailInsuranceService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NikoPatientDetailInsuranceRouteService());
    }

    inactivate(resource) {
        const url = this.routeService.inactivate(resource);
        return this.apiClient.put(url, resource);
    }

    // ISG-2515 (swap): create the new insurance and close out the one identified by oldId. `resource` is the new
    // insurance; its `oldEndDate` is the end date applied to the swapped-out insurance in Niko before it is deleted.
    swap(oldId, resource) {
        const url = this.routeService.swap(oldId);
        return this.apiClient.post(url, resource);
    }
}

export default NikoPatientDetailInsuranceService;